<template>
  <div class="alert alert-info">
    <button
      v-if="showClose"
      type="button"
      class="close"
      data-dismiss="alert"
      aria-hidden="true"
      @click="seen()">&times;
    </button>
    <strong>{{ title }}</strong>
    <vue-markdown
      :source="description"
      class="description"
    />
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
    components: {
        VueMarkdown,
    },

    props: {
        title: {
            type: String,
            required: true,
        },

        description: {
            type: String,
            required: true,
        },

        api: {
            type: String,
            required: false,
            default: window.location.toString(),
        },

        showClose: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    methods: {
        seen() {
            if (this.api) {
                axios.post(this.api);
            }
        },
    },
};
</script>

<style lang="scss">
.description {
    p {
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/broadcast-notice.vue